<template>
    <div class="row">
        <div class="col-12 px-1">
            <ob1-message-alerte
                class="max-width-bloc"
                :title="title"
                :text="text"
                :link-href="linkHref"
                :link-label="linkLabel"
                type="info"
                :with-arrow-link="true"
                :is-simple-alerte="false"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "IncentiveAuthenticate",
    props: {
        title: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        linkHref: {
            type: String,
            required: true
        },
        linkLabel: {
            type: String,
            required: true
        }
    }
}
</script>
